export { default, DEFAULT_FONT_SIZE_LIST, HEADLINE_FONT_SIZE_LIST } from './FontTools';
